import { ACTIONS } from './action.js';

export function auditReducer(state, action) {

  switch (action.type) {

      case ACTIONS.FETCH:
        return action.payload;

      case ACTIONS.CREATE:
        return [...state, action.payload];

      case ACTIONS.EDIT:
        return state.map(question => {
          if (question.QUESTION_ID === action.payload.QUESTION_ID) {
            return { ...question, ...action.payload }
          }

          return question;
        });

      default:
        return state;
  }
}

export function scheduleReducer(state, action) {

  switch (action.type) {
    case ACTIONS.FETCH:
        return action.payload;

    case ACTIONS.EDIT:
      return {
        ...state,
        ...action.payload,
      };
  }
}